import Validator from '../../../utilities/validator/form/index'

class FormControl {
    constructor() {
        this.element = null;
        this.type = null;
        this.maxlength = null;
        this.count = null;
        this.validationType = null;
        this.errorMessage = '';
    }

    init() {
        if (!this.element) {
            console.warn('No root node set.');
            return;
        }

        if (!this.getControlElement()) {
            console.warn('No control node set.');
            return;
        }

        if (!this.type || !this.validationType) {
            console.warn('No control type or validation type set.');
            return;
        }

        if (!!this.getControlElement().value) {
            this.onInputFocus();
        } else {
            this.element.classList.add('clean');
        }

        this.initEventListeners();
    }

    getControlElement() {
        return this.element.querySelector('[data-control]');
    }

    getErrorElement() {
        return this.element.querySelector('[data-error]');
    }

    initEventListeners() {
        this.bindEventListeners(this.getControlElement());
    }

    bindEventListeners(element) {
        element.addEventListener('invalid', (event) => {
            this.onInputInvalid(event);
        });
        element.addEventListener('blur', (event) => {
            this.onInputBlur(event);
        });
        element.addEventListener('change', (event) => {
            this.onInputChange(event);
        });
        element.addEventListener('input', (event) => {
            this.onInputChange(event);
        });
        element.addEventListener('focus', (event) => {
            this.onInputFocus(event);
        });
    }

    onInputInvalid() {
        this.handleValidate();
    }

    onInputChange() {
        this.setValidState('');
    }

    onInputBlur() {
        this.handleValidate();
    }

    onInputFocus() {
        this.element.classList.remove('clean');
        this.element.classList.add('dirty');
    }

    handleValidate() {
        const element = this.getControlElement();

        this.setValidState(
            Validator.checkValidation({
                element,
                type: this.validationType
            })
        );
    }

    resetField(event) {
        event.preventDefault();
        let element = this.getControlElement();

        element.value = '';
        element.focus();
        element.click();
    }

    setValidState(message) {
        let validationMessage = message;

        Validator.setValidState({
            element: this.getControlElement(),
            message: validationMessage
        });

        this.setErrorState(validationMessage);
    }

    setErrorState(validationMessage) {
        // This can be handled directly with jsx
        if (!!validationMessage && validationMessage !== '') {
            this.element.classList.add('error');
            this.getErrorElement().hidden = false;
            this.getErrorElement().textContent = validationMessage;
        } else {
            this.element.classList.remove('error');
            this.getErrorElement().hidden = true;
            this.getErrorElement().textContent = validationMessage;
        }

        this.errorMessage = validationMessage;
    }
}

export default FormControl;
